import React, {useEffect} from "react";
import {Heading, Container, Content, Footer} from "./elements/layout";
import track, {setPageTitle, setPageDescription} from "./utility";
import SignInCTA from "./elements/signincta/SignInCTA";
import WebConstant from "./WebConstant.jsx";
import Api from "./services/Api.js";

const urlParams = new URLSearchParams(window.location.search);
const appId = urlParams.get(WebConstant.SSO_APP_ID);
const DURL = urlParams.get(WebConstant.DURL);
const idp   = urlParams.get(WebConstant.SSO_IDP);

let studentSignUp, profSignUp;

const SignUp = (props) => {
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {

        const getSignupUrl = async (idp, appId, DURL) => {
            if (!idp){
                idp = sessionStorage.getItem(WebConstant.IDP);
            }
            if (!appId){
                const appIdFromSession = sessionStorage.getItem(WebConstant.SSO_APP_ID);
                if (appIdFromSession && !isNaN(appIdFromSession) && Number(appIdFromSession) > 0) {
                    appId = Number(appIdFromSession);
                }
            }
            if (!DURL){
                DURL = sessionStorage.getItem(WebConstant.DURL);
            }

            //console.log(`-----idp=${idp}, appId=${appId}, DURL=${DURL}`);
            const signupUrlResponse = await Api.getSignupUrl(idp, appId, DURL);

            sessionStorage.removeItem(WebConstant.IDP);
            sessionStorage.removeItem(WebConstant.DURL);
            sessionStorage.removeItem(WebConstant.SSO_APP_ID);

            if (signupUrlResponse){
                if (signupUrlResponse.signupUrl) {
                    //console.log(`------signupUrl=${signupUrl}`);
                    window.location.href = signupUrlResponse.signupUrl;
                    return;
                }
                studentSignUp = signupUrlResponse.studentSignupUrl;
                profSignUp = signupUrlResponse.profSignupUrl;
            }
            setLoading(false);
        }

        setPageTitle("Account Sign Up");
        setPageDescription(
            "Create a College Board account to access our tools and services."
        );
        track("select-type", appId, "iamreg");

        getSignupUrl(idp, appId, DURL);

    }, []);

    if (loading) {
        return null;
    }

    return (
        <Container pageName="iam-account-create">
            <Heading>
                <h2>Create Your College Board Account</h2>
                <p className="cb-margin-top-8 cb-font-weight-light">
                    Which type of account do you
                </p>
                <p className="cb-no-margin cb-font-weight-light">
                    want to <strong>create</strong>?
                </p>
            </Heading>
            <Content>
                <a
                    role="button"
                    href={studentSignUp}
                    className="cb-btn cb-btn-lg cb-btn-primary cb-width-100"
                >
                    <span className="svg-student" aria-hidden={true}></span>
                    <span>Student</span>
                </a>
                <a
                    role="button"
                    href={profSignUp}
                    className="cb-btn cb-btn-lg cb-btn-primary cb-width-100"
                >
                    <span className="svg-educator" aria-hidden={true}></span>
                    <span>Educator</span>
                </a>
            </Content>
            <Footer>
                <SignInCTA button={true}/>
            </Footer>
        </Container>
    );
};

export default SignUp;
